import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltCommentDialogStatusDropdownTriggerArrowWireframe from './VeltCommentDialogStatusDropdownTriggerArrowWireframe/VeltCommentDialogStatusDropdownTriggerArrowWireframe';
import VeltCommentDialogStatusDropdownTriggerIconWireframe from './VeltCommentDialogStatusDropdownTriggerIconWireframe/VeltCommentDialogStatusDropdownTriggerIconWireframe';
import VeltCommentDialogStatusDropdownTriggerNameWireframe from './VeltCommentDialogStatusDropdownTriggerNameWireframe/VeltCommentDialogStatusDropdownTriggerNameWireframe';
;
var VeltCommentDialogStatusDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatusDropdownTriggerWireframe.Arrow = VeltCommentDialogStatusDropdownTriggerArrowWireframe;
VeltCommentDialogStatusDropdownTriggerWireframe.Name = VeltCommentDialogStatusDropdownTriggerNameWireframe;
VeltCommentDialogStatusDropdownTriggerWireframe.Icon = VeltCommentDialogStatusDropdownTriggerIconWireframe;
export default VeltCommentDialogStatusDropdownTriggerWireframe;
